<template>
  <div class="offerList" v-if="details.groupSize > 0">
    <h6 class="prdt_sub_hdng">Offers</h6>
    <ul class="list">
        <li class="item"><span>01</span> 2 दोस्तों की खरीद पूरी होते ही कैशबैक पाओ |</li>
        <li class="item"><span>02</span> अपने आर्डर को वाट्सऐप स्टेटस पर लगाए और 24 घंटे बाद पाए नया डिस्काउंट कोड.</li>
    </ul>
  </div>
</template>

<script>
import ApiCaller from "../../../utils/apicaller";
import constant from "../../../utils/constant";
export default {
  name: "OfferList",
  props: {
    dataShareAndEarn: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      details: {},
    };
  },
  watch: {
    dataShareAndEarn() {
      this.details = this.dataShareAndEarn;
    }
  },
  methods: {
  },
  mounted() {
    this.details = this.dataShareAndEarn;
  }
};
</script>
    